import React from 'react'
import { Typography } from 'antd'
import { useTranslation } from 'next-i18next'

const ClickHereColumn = ({ url }: { url: string }) => {
  const { t } = useTranslation()

  return (
    <Typography.Title level={5}>
      <a href={url} target='_blank' rel='noopener noreferrer'>
        {t('general.ClickHere')}
      </a>
    </Typography.Title>
  )
}

export default ClickHereColumn
